module.exports = __webpack_public_path__ + "img/page_14.3a60523f.png";